import { Controller } from '@hotwired/stimulus'
import { prefersReducedMotion } from './mixins/reduced_motion'

export default class extends Controller {
  static targets = ['field', 'tile', 'keys']

  connect () {
    this.fired = false
    if (prefersReducedMotion()) {
      this.tileTargets.forEach(t => { t.style.opacity = '1' })
      return
    }
    this.tileTargets.forEach(t => { t.style.opacity = '0' })

    this.observer = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && !this.fired) {
        this.fired = true
        this.timer = setTimeout(() => this.burst(), 650)
      }
    }, { threshold: 0.35 })
    this.observer.observe(this.element)
  }

  disconnect () {
    this.observer?.disconnect()
    clearTimeout(this.timer)
  }

  burst () {
    const keys = this.center(this.hasKeysTarget ? this.keysTarget : this.element)
    this.tileTargets.forEach(tile => {
      const c = this.center(tile)
      tile.style.transition = 'none'
      tile.style.transform = `translate(${Math.round(keys.x - c.x)}px, ${Math.round(keys.y - c.y)}px) scale(0.2)`
      tile.style.opacity = '0'
    })
    this.element.getBoundingClientRect() // eslint-disable-line no-unused-expressions

    this.pressKeys()

    this.tileTargets.forEach((tile, i) => {
      setTimeout(() => {
        tile.style.transition = 'transform .75s cubic-bezier(.18,.9,.3,1.25), opacity .5s ease'
        tile.style.opacity = '1'
        tile.style.transform = 'translate(0, 0) scale(1)'
        const onEnd = e => {
          if (e.propertyName !== 'transform') return
          tile.removeEventListener('transitionend', onEnd)
          tile.style.transition = ''
          tile.style.transform = ''
          tile.style.animationDuration = `${5 + (i % 4)}s`
          tile.style.animationDelay = `${(i % 5) * 0.25}s`
          tile.classList.add('key-burst-floating')
        }
        tile.addEventListener('transitionend', onEnd)
      }, i * 65)
    })
  }

  pressKeys () {
    if (!this.hasKeysTarget) return
    this.keysTarget.classList.add('key-burst-press')
    setTimeout(() => this.keysTarget.classList.remove('key-burst-press'), 200)
  }

  center (el) {
    const r = el.getBoundingClientRect()
    return { x: r.left + r.width / 2, y: r.top + r.height / 2 }
  }
}
